var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-arrow-left")]),_vm._v(" Parcels")],1)]}}])},[_c('span',[_vm._v("Click to go back to PARCEL page.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }